import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { NgxSelectModule } from 'ngx-select-ex';
import { PresentByListComponent} from './present-by-list.component';
import {PresentByColumnComponent} from './present-by-column.component';
import {PresentByLargeIconsComponent} from './present-by-large-icons.component';
import {TranslatePipeModule} from '../translate/translate.pipe.module';
import {FileChooserListElementModule} from '../FileChooserListElement/file-chooser-list-element.module';
import {ContextMenuModule} from '../context-menu/context-menu.module';
import {GenericModalModule} from '../modal/generic-modal.module';
import {ImportDuplicateModalModule} from '../import-duplicate-modal/import-duplicate-modal.module';
import {SharedRefreshService} from '../service/sharedRefreshService';
import {NotepadModule} from '../notepadApp/notepad.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslatePipeModule,
        FormsModule,
        ReactiveFormsModule,
        NgxSelectModule,
        FileChooserListElementModule,
        ContextMenuModule,
        GenericModalModule,
        ImportDuplicateModalModule,
        NotepadModule
    ],
  declarations: [PresentByListComponent,PresentByColumnComponent,PresentByLargeIconsComponent],
  providers: [SharedRefreshService],
  exports: [PresentByListComponent,PresentByColumnComponent,PresentByLargeIconsComponent]
})

export class FileChooserPresentationModule {

}
